export default "__VITE_ASSET__e53bae89__"